import { breakpoint, colors, fontWeight, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  wrapper: css({
    padding: spacing.large,
    backgroundColor: colors.white,

    [mediaQueryHelper(breakpoint.phone)]: {
      padding: 80,
    },
  }),

  countContainer: css({
    width: '100%',
    margin: 'auto',
    maxWidth: 815,
  }),

  heading: css({
    width: '100%',
    margin: 'auto',
    fontWeight: fontWeight.semiBold,
    fontSize: 18,
    lineHeight: '120%',
    color: '#131F4A',
    textAlign: 'left',

    span: {
      color: colors.cornflowerBlue,
      textDecoration: 'underline',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: 32,
      maxWidth: 600,
      lineHeight: '140%',
      fontWeight: fontWeight.bold,
      textAlign: 'center',
    },
  }),

  desktopContainer: css({
    display: 'none',

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'grid',
    },
  }),

  countDetailsGrid: css({
    display: 'grid',
    gridRowGap: spacing.default,
    width: '100%',
    margin: 'auto',
    padding: shorthandHelper([spacing.medium, 0]),
    gridTemplateColumns: 'unset',

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'grid',
      marginTop: spacing.large,
      maxWidth: 815,
      gridColumnGap: spacing.default,
      gridRowGap: 0,
      gridTemplateColumns: 'repeat(3, 1fr)',
      padding: 0,
    },
  }),

  iconTextColumn: css({
    display: 'flex',
    flexDirection: 'row',
    color: colors.scorpion,
    lineHeight: '140%',

    img: {
      marginRight: spacing.medium,
      height: spacing.large,
    },

    p: {
      margin: 0,
    },

    span: {
      color: '#131F4A',
      fontWeight: fontWeight.bold,
    },
  }),
}

export default styles
